'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var ItemClaimSummaryProvider = require('../../../../common/views/ClaimSummary/item/ItemClaimSummaryProvider.js');
var ItemClaimSummaryViewRoot = require('../../../../common/views/ClaimSummary/item/ItemClaimSummaryViewRoot.js');
var ClaimSummaryViewContainer = require('./components/ClaimSummaryViewContainer.js');
var ItemClaimSummaryDetails = require('../../../../common/views/ClaimSummary/item/ItemClaimSummaryDetails.js');
var ClaimSummaryHeader = require('./components/ClaimSummaryHeader.js');
var useCreateClaimMutation = require('./useCreateClaimMutation.js');
var AgentNavigatorProvider = require('../../providers/AgentNavigatorProvider.js');
var IframeHeight = require('../../components/IframeHeight.js');
var ClaimSummarySection = require('../../../../common/views/ClaimSummary/components/ClaimSummarySection.js');
var ClaimSummarySectionHeader = require('./components/ClaimSummarySectionHeader.js');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var ClaimSummaryAppeasement = require('../../../../common/views/ClaimSummary/components/ClaimSummaryAppeasement.js');
var nthHookSettings = require('@narvar/nth-hook-settings');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ItemClaimSummary = () => {
  const {
    submitClaimStatus,
    onBack,
    onSubmit,
    appeasement,
    setAppeasement
  } = ItemClaimSummaryProvider.useItemClaimSummary();
  const {
    navigateToOrderOverview
  } = AgentNavigatorProvider.useAgentNavigator();
  const {
    claimsSummaryItemSubtitle,
    claimsSummaryAppeasementTitle
  } = nthHookTranslations.useTranslations();
  const {
    claimAppeasements
  } = nthHookSettings.useSettings();
  return /*#__PURE__*/React__default["default"].createElement(ClaimSummaryViewContainer["default"], {
    onBackClick: onBack,
    onDismissClick: navigateToOrderOverview,
    onNextClick: onSubmit,
    submitClaimStatus: submitClaimStatus
  }, /*#__PURE__*/React__default["default"].createElement(ClaimSummaryHeader["default"], {
    submitClaimStatus: submitClaimStatus
  }), /*#__PURE__*/React__default["default"].createElement(ClaimSummarySection["default"], null, /*#__PURE__*/React__default["default"].createElement(ClaimSummarySectionHeader["default"], null, claimsSummaryItemSubtitle), /*#__PURE__*/React__default["default"].createElement(ItemClaimSummaryDetails["default"], null)), (claimAppeasements === null || claimAppeasements === void 0 ? void 0 : claimAppeasements.enabled) && /*#__PURE__*/React__default["default"].createElement(ClaimSummarySection["default"], null, /*#__PURE__*/React__default["default"].createElement(ClaimSummarySectionHeader["default"], null, claimsSummaryAppeasementTitle), /*#__PURE__*/React__default["default"].createElement(ClaimSummaryAppeasement["default"], {
    appeasement: appeasement,
    setAppeasement: setAppeasement
  })));
};
const ItemClaimSummaryWithViewRoot = () => /*#__PURE__*/React__default["default"].createElement(IframeHeight["default"], null, /*#__PURE__*/React__default["default"].createElement(ItemClaimSummaryViewRoot["default"], {
  useCreateClaimMutation: useCreateClaimMutation["default"]
}, /*#__PURE__*/React__default["default"].createElement(ItemClaimSummary, null)));
var ItemClaimSummary$1 = nthHookTranslations.withTranslationsProvider(nthHookSettings.withSettingsProvider(ItemClaimSummaryWithViewRoot, {
  settingsRequested: `
    claimAppeasements {
      enabled
    }
  `
}), {
  translationKeys: ['claimsSummaryItemSubtitle', 'claimsSummaryAppeasementTitle']
});

exports["default"] = ItemClaimSummary$1;
